import React from 'react';

const TablaMantenimiento = props => (
  <tbody>
    {
      props.lugares.length ?
        props.lugares.map(lugar => (
          <tr key={lugar.codFilial}>
            <td>{lugar.codFilial}</td>
            <td>{lugar.nomFilial}</td>
            <td>{lugar.indTipoFilial}</td>
            <td>{lugar.indInactivo}</td>
            <td>
              <button className='btn btn-blue' onClick={() => props.openModal('mantenimiento', lugar)}>Editar</button>
            </td>
          </tr>
        )) :
        <tr>
          <td colSpan={5}>No hay resultados</td>
        </tr>
    }
  </tbody>
);

export default TablaMantenimiento;



// WEBPACK FOOTER //
// ./src/pages/MantFilialEntrega/TablaMantenimiento.js